import { useParams } from 'react-router-dom';
import type { Page as PageType } from 'src/types/page';
import { TeamMemberDetail } from 'src/sections/about/team-member-detail';
import { team } from 'src/data/team';
import Error404Page from 'src/pages/404';

const Page: PageType = () => {
  const { slug } = useParams<{ slug: string }>();
  const member = team.find((m) => m.slug === slug);

  if (!member) {
    return <Error404Page />;
  }

  return <TeamMemberDetail member={member} />;
};

export default Page;
